import React from "react";
import Banner from "./Banner";
import TitleSection from "./TitleSection";
import DigInfra from "./DigInfra";
import PropInv from "./PropInv";
import DataBase from "./DataBase";
import FinancialServices from "./FinancialServices";
import MarketArbitrage from "./MarketArbitrage";
import InputSupply from "./InputSupply";

function VaLuePrp() {
  return (
    <>
      <Banner />
      <TitleSection />
      <DigInfra />
      <PropInv />
      <DataBase />
      <FinancialServices />
      <MarketArbitrage />
      <InputSupply />
    </>
  );
}

export default VaLuePrp;
